import * as Schema from "effect/Schema";

export const SupportedDesktopPlatform = Schema.Literal("darwin");
export type SupportedDesktopPlatform = typeof SupportedDesktopPlatform.Type;

export const ExperimentalDesktopPlatform = Schema.Literals(["win32", "linux"]);
export type ExperimentalDesktopPlatform = typeof ExperimentalDesktopPlatform.Type;

export const DesktopClientPlatform = Schema.Union([
  SupportedDesktopPlatform,
  ExperimentalDesktopPlatform,
]);
export type DesktopClientPlatform = typeof DesktopClientPlatform.Type;
